import React from 'react';
import { Link } from 'react-router-dom';
import Author from '../../images/blog/blog-avater/Author3.jpg';
import blogs from '../../api/blogs';
import BlogSidebar from '../BlogSidebar';

const BlogSingle = (props) => {
  const BlogDetails = blogs.find((item) => item.id === '6');

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="wpo-blog-single-section section-padding">
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-blog-content">
              <div className="post format-standard-image">
                <div className="entry-media">
                  <img
                    src={BlogDetails.blogSingleImg}
                    alt="Trabajadora agobiada frente a su computador"
                  />
                </div>
                <div className="entry-meta">
                  <ul>
                    <li>
                      <i className="fi flaticon-user"></i> By{' '}
                      <Link to="/equipo/3">
                        <strong>{BlogDetails.author}</strong>
                      </Link>{' '}
                    </li>
                    <li>
                      <i className="fi flaticon-comment-white-oval-bubble"></i>{' '}
                      Tiempo de Lectura {BlogDetails.comment}
                    </li>
                    <li>
                      <i className="fi flaticon-calendar"></i>{' '}
                      {BlogDetails.create_at}
                    </li>
                  </ul>
                </div>
                <h2>Denunciar y esperar.</h2>
                <p>
                  <em>
                    A dos años de la Ley Karin, el sistema responde con
                    procedimientos donde debería responder con protección.
                  </em>
                </p>
                <p>
                  A dos años de la entrada en vigencia de la Ley N° 21.643 se ha
                  discutido su eficiencia, sus posibles modificaciones e incluso
                  se propuso suspenderla por hasta cinco años, iniciativa
                  descartada en pocos días por el gobierno y por la mesa del
                  Senado. Es pertinente que, ante un sistema colapsado y con
                  plazos que no se cumplen, nos preguntemos cómo perfeccionarla.
                  Sin embargo, creo que la discusión está mirando el lugar
                  equivocado. Casi todo el debate se concentra en la puerta de
                  entrada, esto es, en cuántas denuncias ingresan y cuántas no
                  corresponden, mientras los dos problemas que me parecen más
                  serios ocurren adentro: la protección que se decreta y no se
                  cumple, y la reparación que, al final del procedimiento,
                  simplemente no llega.
                </p>
                <p>
                  Según el último informe estadístico de la Dirección del
                  Trabajo, entre agosto de 2024 y diciembre de 2025 ingresaron
                  66.596 solicitudes de denuncia. De ellas, 26.862 fueron
                  preclasificadas como Ley Karin y 29.382 no lo fueron. Sólo
                  11.088 llegaron a tramitación y apenas 6.105 tienen
                  investigación terminada, con 1.258 vulneraciones constatadas,
                  es decir un 20,6 % de las causas concluidas. Hay, además,
                  15.774 denuncias ya calificadas como Ley Karin que ni siquiera
                  han entrado a tramitación.
                </p>
                <p>
                  De esa distancia entre lo que ingresa y lo que se constata se
                  ha seguido, desde lecturas muy distintas entre sí, una misma
                  conclusión, que el sistema requiere filtros de admisibilidad.
                  Conviene entonces revisar qué permite afirmar ese número. El
                  propio informe enumera por qué se cierran las denuncias que no
                  se califican como Ley Karin, y en esa lista conviven
                  vulneraciones de derechos fundamentales que sí existen pero
                  corresponden a otro procedimiento, denuncias de funcionarios
                  públicos regidos por otro estatuto, causas ya judicializadas
                  y, textualmente, duplicidades, errores de ingreso y errores de
                  etiquetado en los sistemas. Como el informe no desagrega
                  cuántas denuncias corresponden a cada causal, atribuir ese
                  universo a un uso indebido de la ley me parece, al menos,
                  apresurado.
                </p>
                <p>
                  A ello se suma una dificultad que rara vez se menciona. Antes
                  de elegir un procedimiento, el trabajador debe resolver si lo
                  que le ocurrió cabe o no en la definición legal, y sólo
                  después cuál de los caminos disponibles le corresponde, porque
                  puede denunciar por Ley Karin, demandar por tutela de derechos
                  fundamentales, pedir una fiscalización o recurrir al
                  autodespido, este último el más exigente de todos, ya que
                  obliga a dejar el empleo primero y a litigar después.{' '}
                  <strong>
                    Se le pide así a una persona recién hostigada, muchas veces
                    sin abogado, y en el peor momento de su vida laboral,
                    realizar una calificación jurídica que quienes ejercemos la
                    profesión no hacemos sin revisar antecedentes.
                  </strong>
                </p>
                <p>
                  Superada esa primera decisión, el problema siguiente aparece
                  cuando la denuncia ya está en curso. La ley obliga al
                  empleador a adoptar de inmediato medidas de resguardo. La
                  pregunta que casi no se hace es{' '}
                  <strong>
                    qué ocurre cuando el empleador no tiene protocolo de
                    prevención, cuando lo tiene pero es incompleto o
                    insuficiente, cuando aplica una medida que en la práctica no
                    cumple el objetivo de proteger al trabajador o cuando
                    derechamente no aplica
                  </strong>{' '}
                  las medidas.
                </p>
                <p>
                  La Dirección del Trabajo puede multar, y lo ha hecho. Hasta
                  diciembre de 2025 cursó multas por más de cuatro mil
                  cuatrocientos millones de pesos en materias relacionadas con
                  esta ley.{' '}
                  <strong>
                    Es una cifra que demuestra fiscalización y que, al mismo
                    tiempo, no parece decir absolutamente nada sobre si alguien
                    dejó de ser hostigado.
                  </strong>{' '}
                  Mientras la multa ingresa a las arcas fiscales, el trabajador
                  sigue en el mismo espacio, con la misma persona, esperando.
                </p>
                <p>
                  Del mismo modo, cuando las medidas decretadas no se cumplen,
                  la vía que se ofrece en la práctica es presentar una nueva
                  denuncia, lo que supone abrir un expediente nuevo, con plazos
                  nuevos, respecto de un procedimiento que ya estaba en curso,
                  en un sistema con más de quince mil denuncias esperando a
                  tramitación. Cabe preguntarse por qué ese incumplimiento no se
                  resuelve como un incidente de la denuncia principal, con
                  respuesta rápida, en lugar de duplicar el ingreso y volver a
                  la fila.
                </p>
                <blockquote>
                  <p>
                    El segundo problema es el que da título a estas líneas. La
                    Ley Karin previene, investiga y sanciona, pero no siempre
                    repara. Si la denuncia se acoge, la persona denunciada será
                    amonestada, sancionada conforme al reglamento interno o
                    despedida, y ninguna de esas consecuencias alcanza al
                    trabajador afectado, que termina el procedimiento en la
                    misma situación económica y de salud en que lo empezó, sólo
                    que muchos meses después.
                  </p>
                </blockquote>
                <p>
                  La reparación existe, pero está en otra parte, en el juicio de
                  tutela, que el trabajador debe iniciar por su cuenta y que
                  tiene un plazo propio de sesenta días contados desde que el
                  acoso cesa o, a más tardar, desde el término de la relación
                  laboral. La Dirección del Trabajo ha aclarado que ese plazo
                  rige únicamente para la acción judicial y nada tiene que ver
                  con la obligación del empleador de investigar los hechos
                  denunciados por Ley Karin, por antiguos que sean. Son,
                  entonces, dos relojes distintos y sólo uno de ellos corre en
                  contra del trabajador. Más aún, cuando el acoso cesa porque la
                  medida de resguardo funcionó y separó a las partes, ese plazo
                  comienza a correr mientras la investigación sigue su curso
                  durante meses, de modo que el resguardo que protegió a la
                  persona puede ser, al mismo tiempo, lo que puso el reloj en
                  marcha. Si la denuncia administrativa detiene ese reloj es
                  algo que, hasta donde he podido revisar, no está resuelto.
                </p>
                <p>
                  Supongamos que en algún punto de esa espera la persona pierde
                  el trabajo. Es el peor desenlace posible y, sin embargo,{' '}
                  <strong>
                    es también el momento en que la ley se vuelve más precisa
                    sobre lo que le corresponde
                  </strong>
                  , porque quien es despedido puede reclamar una indemnización
                  de entre seis y once remuneraciones, cifra fijada de antemano,
                  mientras quien conserva su empleo no tiene ninguna cifra
                  garantizada y queda entregado a la prueba del daño que logre
                  reunir. Cuesta explicar que la respuesta más definida del
                  sistema aparezca sólo cuando la persona ya perdió el trabajo,
                  y más todavía si se recuerda que esta ley se dictó
                  precisamente para que nadie tuviera que irse de su empleo para
                  dejar de ser hostigado.
                </p>
                <p>
                  Por todo lo anterior, soy de la opinión que suspender la ley o
                  restringir su puerta de entrada no resolvería ninguno de estos
                  dos problemas. Las medidas que a mi juicio harían una
                  diferencia real son de otro orden y ninguna exige desmontar lo
                  construido.
                </p>
                <p>
                  La primera es <strong>orientar en lugar de cerrar</strong>. Si
                  buena parte de lo que hoy se descarta son vulneraciones reales
                  mal encaminadas, la respuesta natural debería ser derivar el
                  relato al procedimiento que corresponda, y no devolverlo con
                  la constancia de que no corresponde.
                </p>
                <p>
                  La segunda es{' '}
                  <strong>
                    tramitar el incumplimiento de las medidas de resguardo
                    dentro de la denuncia que ya está en curso
                  </strong>
                  , con respuesta rápida, en lugar de obligar a un ingreso nuevo
                  que congestiona el sistema y deja desprotegido al trabajador
                  mientras tanto.
                </p>
                <p>
                  La tercera es la más barata y probablemente la que más daño
                  evita. Que al momento de ingresar la denuncia{' '}
                  <strong>
                    se le informe expresamente al trabajador que existe una
                    acción judicial distinta
                  </strong>
                  , con un plazo propio, que ya está corriendo.
                </p>
                <p>
                  La Ley Karin le enseñó a Chile a denunciar el acoso, y eso
                  explica las 66 mil denuncias que hoy se exhiben como síntoma
                  de colapso. Lo que aún no resolvemos es qué hacer con ellas,
                  ni qué queda del trabajador cuando el procedimiento por fin
                  termina.
                </p>
              </div>

              <div className="tag-share clearfix">
                <div className="tag">
                  <span>Tags </span>
                  <ul>
                    <li>
                      <Link>Ley Karin</Link>
                    </li>
                    <li>
                      <Link>Ley N° 21.643</Link>
                    </li>
                    <li>
                      <Link>Acoso Laboral</Link>
                    </li>
                    <li>
                      <Link>Derecho Laboral</Link>
                    </li>
                    <li>
                      <Link>Tutela de Derechos Fundamentales</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="author-box">
                <div className="author-avatar">
                  <Link to="/equipo/3" target="_blank">
                    <img src={Author} alt="Vanessa Chávez Chacaltana" />
                  </Link>
                </div>
                <div className="author-content">
                  <Link
                    onClick={ClickHandler}
                    to="/equipo/3"
                    className="author-name"
                  >
                    Vanessa Chávez Chacaltana
                  </Link>
                  <p>H&A Abogados</p>
                  <div className="socials">
                    <ul className="social-link">
                      <li>
                        <Link to="https://www.linkedin.com/in/vanessachavezch/">
                          <i className="ti-linkedin"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="more-posts">
                <div className="previous-post">
                  <Link
                    onClick={ClickHandler}
                    to="/opinion/desregulacion-emocional-violencia-laboral-ley-21643"
                  >
                    <span className="post-control-link">Anterior</span>
                    <span className="post-name">
                      Desregulación emocional en establecimiento educacional y
                      la violencia en el trabajo contemplada en la Ley N°
                      21.643.
                    </span>
                  </Link>
                </div>
                <div className="next-post">
                  <Link
                    onClick={ClickHandler}
                    to="/opinion/como-prevenir-y-proteger-la-salud-mental-de-sus-trabajadores"
                  >
                    <span className="post-control-link">Siguiente</span>
                    <span className="post-name">
                      ¿Cómo prevenir y proteger la salud mental de sus
                      trabajadores en los fuegos de una cocina?
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <BlogSidebar blLeft={props.blLeft} />
        </div>
      </div>
    </section>
  );
};

export default BlogSingle;
